import { action } from 'satcheljs';
import type PersonalBookingPageSettings from 'owa-service/lib/contract/GetPersonalSchedulingPageResponseMessage';

/**
 * Action to initialize the personal booking page settings in store.
 */
export interface INITIALIZE_PBP_SETTINGSActionMessage {
    pbpSettings: PersonalBookingPageSettings;
}
const initializeSettings: (
    pbpSettings: PersonalBookingPageSettings
) => INITIALIZE_PBP_SETTINGSActionMessage = action(
    'INITIALIZE_PBP_SETTINGS',
    (pbpSettings: PersonalBookingPageSettings): INITIALIZE_PBP_SETTINGSActionMessage => ({
        pbpSettings,
    })
);

export default initializeSettings;
